<template>
  <div class="w-full">
    <b-loading :active.sync="loading" />

    <div class="w-full flex justify-between items-start">
      <Lynx-Title text="Guias Data Vencimento Padrão" />
      <Lynx-Button
        text="Atualizar Guias"
        class="mb-4"
        icon="Reload"
        @click.native="listar"
        size="small"
        icon-size="3"
      />

      <Lynx-Button
        text="Criar data padrão"
        class="mb-4"
        icon="Reload"
        @click.native="openModal({})"
        size="small"
        icon-size="3"
      />
    </div>

    <div class="w-full flex justify-start gap-5 mb-2">
      <label>
        <Lynx-Input
          type="text"
          placeholder="filtre empresa"
          v-model="filtros.empresa_id"
        />
      </label>
    </div>

    <b-table
      backend-pagination
      @page-change="onPageChange"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
      :total="pagination.total"
      :current-page="pagination.current_page"
      :per-page="pagination.per_page"
      :columns="columns"
      :data="getListaGuiaVencimentoPadrao"
      striped
      :sticky-header="true"
      paginated
      :height="pagination.per_page == 10 ? '680' : '100%'"
    >
      <template slot-scope="props" v-if="props.row.empresa_id != null">
        <b-table-column style="width: 100px" field="id">
          {{ props.row.empresa_id }}
        </b-table-column>

        <b-table-column field="tipo">
          {{ props.row.empresa.razao_social }}
        </b-table-column>

        <b-table-column field="tipo">
          {{ props.row.tipo }}
        </b-table-column>
        <b-table-column field="data_vencimento">
          {{ props.row.data_vencimento | formatEnToBr }}
        </b-table-column>
        <b-table-column field="acoes">
          <Lynx-Button
            class="rounded-full py-2 mr-2"
            size="small"
            @click.native="openModal(props.row)"
            icon="Edit"
            icon-size="4"
          />
        </b-table-column>
      </template>
      <template v-slot:empty>
        <NotFoundData text="Nenhum convite encontrado!" />
      </template>
    </b-table>
    <div class="float-left" style="margin-top: -60px">
      <b-pagination
        :total="pagination.total"
        :current.sync="current_page"
        :per-page="pagination.per_page"
      />
    </div>

    <b-modal :active.sync="modal" class="custom-modal">
      <div class="bg-neutral-300 p-8" :style="'height:' + height + 'px'">
        <Lynx-Title text="Guia Data Vencimento Padrão" />

        <div class="flex grid-3 gap-3">
          <b-field label="Empresa Id" class="w-1/3">
            <Lynx-Input v-model="form.empresa_id" placeholder="Empresa Id" />
          </b-field>
          <b-field label="Data Vencimento" class="w-1/3">
            <InputDate
              @click.native="height == 300 ? (height = 600) : (height = 300)"
              v-click-outside="onClickOutside"
              v-model="form.data_vencimento"
              placeholder="Data Vencimento"
              icon="calendar-today"
            ></InputDate>
          </b-field>
          <b-field label="Tipo" class="w-1/3">
            <treeselect
              v-model="form.tipo"
              :options="tipo"
              placeholder="Selecione o Tipo"
            />
          </b-field>
        </div>

        <div class="flex justify-end">
          <Lynx-Button @click.native="confirm(!form.id ? 'cria' : 'edita')">{{
            !form.id ? "Cadastrar" : "Atualizar"
          }}</Lynx-Button>
        </div>
        <!-- Rest of the code -->
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import Treeselect from "@riophae/vue-treeselect";
import NotFoundData from "@/components/layouts/NotFoundData";
import InputDate from "@/components/helpers/InputDate";
import { formatEnToBr } from "@/utils/momentHelpers";

export default {
  name: "GuiasDataVencimentoPadrao",
  components: {
    Treeselect,
    NotFoundData,
    InputDate,
  },
  data() {
    return {
      height: 300,
      modal: false,
      current_page: 1,
      form: {
        data_vencimento: null,
        empresa_id: null,
        tipo: null,
      },
      tipo: [{ id: "iss", label: "ISS" }],
      filtros: {
        page: 1,
        empresa_id: null,
      },
      columns: [
        {
          field: "empresas_id",
          label: "ID",
          searchable: false,
          sortable: true,
        },
        {
          field: "empresa.razao_social",
          label: "Razão Social",
        },
        {
          field: "data_vencimento",
          label: "Data Vencimento",
        },
        {
          field: "tipo",
          label: "Tipo",
        },
        {
          field: "",
          label: "acoes",
        },
      ],
    };
  },
  filters: {
    formatEnToBr,
  },
  computed: {
    ...mapGetters("guiaDataVencimentoPadrao", [
      "getListaGuiaVencimentoPadrao",
      "pagination",
    ]),
    mensagem_alert() {
      return this.$store.state.guiaDataVencimentoPadrao.mensagem_alert;
    },
  },
  watch: {
    current_page() {
      this.filtros.page = this.current_page;
    },
  },
  created() {
    this.listar();
  },
  methods: {
    ...mapActions("guiaDataVencimentoPadrao", [
      "listar_guia_vencimento_padrao",
      "create_guia_vencimento_padrao",
      "update_guia_vencimento_padrao",
    ]),
    onClickOutside() {
      this.height = 300;
    },

    async confirm(tipo) {
      await this.$buefy.dialog.confirm({
        message: `Esta ação  ` + tipo + ` um Cartao credito no sistema?`,
        confirmText: "Sim",
        cancelText: "Não",
        type: "is-success",
        onConfirm: () => {
          if (tipo == "cria") this.create();
          if (tipo == "edita") this.update();
        },
      });
    },
    async create() {
      await this.create_guia_vencimento_padrao(this.form);
      if (this.mensagem_alert.tipo == "success") {
        this.modal = false;
        this.$snack.success(this.mensagem_alert.message);
      } else {
        this.$snack.error(this.mensagem_alert.message);
      }
      this.listar();
    },
    async update() {
      await this.update_guia_vencimento_padrao(this.form);
      if (this.mensagem_alert.tipo == "success") {
        this.modal = false;
        this.$snack.success(this.mensagem_alert.message);
      } else {
        this.$snack.error(this.mensagem_alert.message);
      }
      this.listar();
    },
    listar() {
      this.loading = true;

      const { page, empresa_id, tipo } = this.filtros;

      // Construa a string da rota com base nos valores dos filtros
      let rota = "guia-data-vencimento-padrao?";

      if (page) rota += `page=${page}&`;
      if (tipo) rota += `tipo=${tipo}&`;
      if (empresa_id) rota += `empresa_id=${empresa_id}&`;

      // Remova o último '&' se existir
      rota = rota.slice(0, -1);

      this.listar_guia_vencimento_padrao(rota);

      this.loading = false;
    },
    onPageChange(page) {
      this.current_page = page;
    },
    openModal(guiaDataVencimentoPadrao) {
      this.modal = true;
      if (guiaDataVencimentoPadrao.id) {
        this.form = {
          id: guiaDataVencimentoPadrao.id,
          data_vencimento: guiaDataVencimentoPadrao.data_vencimento,
          empresa_id: guiaDataVencimentoPadrao.empresa_id,
          tipo: guiaDataVencimentoPadrao.tipo,
        };
      }else{
        this.form = {
          data_vencimento: null,
          empresa_id: null,
          tipo: null,
        };
      }
    },
  },
};
</script>
<style scoped>
.custom-modal .modal-card {
  overflow: visible !important;
}

.custom-modal .modal-content {
  overflow: visible !important;
}
</style>